/** Stands in for the token in the example request; the real one is shown once, on create. */
export const API_TOKEN_PLACEHOLDER = '<your API token>'

/**
 * The token API under the app's API base: `https://host/v1` → `https://host/v1/api-token`.
 * `null` when the base is unknown.
 */
export const buildTokenApiBaseUrl = (
  apiBaseUrl: string | null
): string | null =>
  apiBaseUrl ? `${apiBaseUrl.replace(/\/+$/, '')}/api-token` : null

/**
 * The token API's documentation, served at the root of the API host:
 * `https://host/v1` → `https://host/docs/api`. `null` when the base is unknown
 * or not a URL.
 */
export const buildApiDocsUrl = (apiBaseUrl: string | null): string | null => {
  if (!apiBaseUrl) {
    return null
  }
  try {
    return `${new URL(apiBaseUrl).origin}/docs/api`
  } catch {
    return null
  }
}

/** A first request to try with a new token: who the token acts as. */
export const buildApiTokenExampleRequest = (tokenApiBaseUrl: string): string =>
  [
    `curl ${tokenApiBaseUrl}/user \\`,
    `  -H "Authorization: Bearer ${API_TOKEN_PLACEHOLDER}" \\`,
    '  -H "Accept: application/json"',
  ].join('\n')
